import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';

import { StateManagerProjectService } from '@state-manager';
import { ToolbarService } from '@shared/toolbar/toolbar.service';
import { ViewerService } from '@viewer/viewer.service';
import { ExitActionService } from '../viewer-right-panel/project-actions/exit-action/exit-action.service';
import { CasedashboardService } from '../case-dashboard/casedashboard.service';
import { constantStrings } from '@shared/helpers/constants';

@Component({
  selector: 'app-mri-editer',
  templateUrl: 'MRIEditer.component.html',
  styleUrls: ['MRIEditer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MRIEditerComponent implements OnInit, OnDestroy {
  caseId;
  RouteParamsObs;
  caseDetails$: Observable<any>;
  caseDetails: any = null;

  @ViewChild('projectLeftPortal', { static: true })
  projectLeftPortal!: TemplateRef<any>;
  @ViewChild('projectCenterPortal', { static: true })
  projectCenterPortal!: TemplateRef<any>;

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  private _unsubscribe = new Subject();

  constructor(
    public stateProjectManagerService: StateManagerProjectService,
    private _snackBar: MatSnackBar,
    private _toolbarService: ToolbarService,
    private _viewerService: ViewerService,
    private _cdr: ChangeDetectorRef,
    private _exitActionService: ExitActionService,
    private _caseDashboardService: CasedashboardService
  ) {
    this.stateProjectManagerService.init();
  }

  ngOnInit(): void {
    this._toolbarService.setLeftPortal(
      new TemplatePortal(this.projectLeftPortal, undefined!, {})
    );

    this.stateProjectManagerService.isPanelForClaimantUserVisible$
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((value) => {
        setTimeout(() => this._viewerService.uiGridWasChanged.emit(), 0);
        this._cdr.markForCheck();
      });

      this.caseDetails$ = this.getCasedetails();    
      this.caseDetails$.pipe(map((details) => {
        this.stateProjectManagerService.isCaseApproved = details.approved;
        this.stateProjectManagerService.isCaseRejected = details.rejected;
        this.stateProjectManagerService.caseType = details.caseType;
        this.stateProjectManagerService.caseImagingType = details.imagingType;
        this.caseDetails = details;
        this._showInfoAboutClaimantUser(details.claimantUserName);
      }))
      .subscribe();
  }

  openInfoForSaveUpdatedMask(): void {
    this._snackBar.open(
      'The process of saving the changed mask is underway',
      undefined,
      {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      }
    );
  }

  ngOnDestroy(): void {
    // this.RouteParamsObs._unsubscribe();
    this._unsubscribe.next(undefined);
    this._unsubscribe.complete();
  }

  public getIdentifier(): string {
    return this.stateProjectManagerService.caseId;
  }

  getCasedetails() {
    return this._caseDashboardService.getCasedetails(this.stateProjectManagerService.caseId);
  }

  canDeactivate(): boolean {
    if (
      this.stateProjectManagerService.isDisabledAllToolsForChangeMask ||
      !this.stateProjectManagerService.isChangesBetweenMasks ||
      this.stateProjectManagerService.isAlreadyClosedApp || !this.stateProjectManagerService.isViewerLoaded
    ) {
      return true;
    }
    this._exitActionService.openConfirmDialog();
    return false;
  }
 
  replaceNull(data: string | null): { modifiedString: string, length: number } {
    if (data == null) {
      return { modifiedString: '', length: 0 };
    }
    const modifiedString = data.replace(/null/g, '');
    return { modifiedString, length: modifiedString.length };
  }

  private _showInfoAboutClaimantUser(claimantUser: string) {
    const user = JSON.parse(localStorage.getItem('userDetails') || '{}');
    this.stateProjectManagerService.currentUserName = user.userName;

    if (
      ![user.userName, null, constantStrings.NOT_APPLICABLE].includes(claimantUser) 
      && !this.stateProjectManagerService.isCaseApproved && !this.stateProjectManagerService.isCaseRejected
    ) {
      this.stateProjectManagerService.isPanelForClaimantUserVisible = true;
    }
  }
}
